import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageOpenRecentProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageOpenRecentProjectController.php:18
* @route '/product-page/{configurableProduct}/recent-projects/{mediaclipProjectId}/open'
*/
const ProductPageOpenRecentProjectController = (args: { configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number } | [configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ProductPageOpenRecentProjectController.url(args, options),
    method: 'post',
})

ProductPageOpenRecentProjectController.definition = {
    methods: ["post"],
    url: '/product-page/{configurableProduct}/recent-projects/{mediaclipProjectId}/open',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageOpenRecentProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageOpenRecentProjectController.php:18
* @route '/product-page/{configurableProduct}/recent-projects/{mediaclipProjectId}/open'
*/
ProductPageOpenRecentProjectController.url = (args: { configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number } | [configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            configurableProduct: args[0],
            mediaclipProjectId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        configurableProduct: typeof args.configurableProduct === 'object'
        ? args.configurableProduct.url_key
        : args.configurableProduct,
        mediaclipProjectId: args.mediaclipProjectId,
    }

    return ProductPageOpenRecentProjectController.definition.url
            .replace('{configurableProduct}', parsedArgs.configurableProduct.toString())
            .replace('{mediaclipProjectId}', parsedArgs.mediaclipProjectId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageOpenRecentProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageOpenRecentProjectController.php:18
* @route '/product-page/{configurableProduct}/recent-projects/{mediaclipProjectId}/open'
*/
ProductPageOpenRecentProjectController.post = (args: { configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number } | [configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ProductPageOpenRecentProjectController.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageOpenRecentProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageOpenRecentProjectController.php:18
* @route '/product-page/{configurableProduct}/recent-projects/{mediaclipProjectId}/open'
*/
const ProductPageOpenRecentProjectControllerForm = (args: { configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number } | [configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ProductPageOpenRecentProjectController.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageOpenRecentProjectController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageOpenRecentProjectController.php:18
* @route '/product-page/{configurableProduct}/recent-projects/{mediaclipProjectId}/open'
*/
ProductPageOpenRecentProjectControllerForm.post = (args: { configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number } | [configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ProductPageOpenRecentProjectController.url(args, options),
    method: 'post',
})

ProductPageOpenRecentProjectController.form = ProductPageOpenRecentProjectControllerForm

export default ProductPageOpenRecentProjectController